module.exports = __webpack_public_path__ + "static/img/3x.1f7d7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/3x.png
// module id = Qrcm
// module chunks = 64